import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const PropsTable = makeShortcode("PropsTable");
const PropsTableRow = makeShortcode("PropsTableRow");
const PropsTableBasePropRows = makeShortcode("PropsTableBasePropRows");
const Link = makeShortcode("Link");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import {RelativeTime} from '@primer/react'
`}</code></pre>
    <p>{`Formats a timestamp as a localized string or as relative text that auto-updates in the user's browser.`}</p>
    <h2>{`Examples`}</h2>
    <h3>{`Default`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <RelativeTime datetime="2014-04-01T16:30:00-08:00" />
  <br/>
  <RelativeTime date={new Date('2014-04-01T16:30:00-08:00')} format="micro" tense="past"/>
  <br/>
  <RelativeTime datetime="2014-04-01T16:30:00-08:00" format="elapsed"/>
</>
`}</code></pre>
    <h2>{`Props`}</h2>
    <h3>{`RelativeTime`}</h3>
    <PropsTable mdxType="PropsTable">
  <PropsTableRow name="datetime" type="string" required description="An ISO8601 time represeting the time" mdxType="PropsTableRow" />
  <PropsTableRow name="date" type="string" description="Instead of passing the `datetime`, it is possible to pass a full `Date` object into the `date` prop" mdxType="PropsTableRow" />
  <PropsTableRow name="format" type="'auto' | 'micro' | 'elapsed'" defaultValue="'auto'" description="The format with which to display the time" mdxType="PropsTableRow" />
  <PropsTableRow name="tense" type="'auto' | 'past' | 'future'" defaultValue="'auto'" description="The tense to use when displaying a relative time" mdxType="PropsTableRow" />
  <PropsTableRow name="precision" type="'year' | 'month' | 'day' | 'hour' | 'minute' | 'second'" defaultValue="'second'" description="The precision to use when displaying an elapsed time" mdxType="PropsTableRow" />
  <PropsTableRow name="threshold" type="string" defaultValue="'P30D'" description="The threshold (ISO8601 duration) to display relative dates within" mdxType="PropsTableRow" />
  <PropsTableRow name="prefix" type="string" defaultValue="'on'" description="The prefix to use when displaying a localised (non relative) date" mdxType="PropsTableRow" />
  <PropsTableRow name="second" type="'numeric' | '2-digit'" description="The format with which to render seconds" mdxType="PropsTableRow" />
  <PropsTableRow name="minute" type="'numeric' | '2-digit'" description="The format with which to render minutes" mdxType="PropsTableRow" />
  <PropsTableRow name="hour" type="'numeric' | '2-digit'" description="The format with which to render hours" mdxType="PropsTableRow" />
  <PropsTableRow name="weekday" type="'short' | 'long' | 'narrow'" description="The format with which to render weekdays" mdxType="PropsTableRow" />
  <PropsTableRow name="day" type="'numeric' | '2-digit'" description="The format with which to render days" mdxType="PropsTableRow" />
  <PropsTableRow name="month" type="'numeric' | '2-digit' | 'short' | 'long' | 'narrow'" defaultValue="'numeric'" description="The format with which to render months" mdxType="PropsTableRow" />
  <PropsTableRow name="year" type="'numeric' | '2-digit'" description="The format with which to render years" mdxType="PropsTableRow" />
  <PropsTableRow name="timeZoneName" type="'long' | 'short' | 'shortOffset' | 'longOffset' | 'shortGeneric' | 'longGeneric'" description="The format with which to render the time zone" mdxType="PropsTableRow" />
  <PropsTableBasePropRows elementType="relative-time" refType="RelativeTimeElement" passthroughPropsLink={<Link href="https://github.com/github/relative-time-element/" mdxType="Link">@github/relative-time-element</Link>} mdxType="PropsTableBasePropRows" />
    </PropsTable>
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: false,
      usageExamplesDocumented: true,
      hasStorybookStories: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: true,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      